import type { NavItem } from "@yk/ui";
// AlertTriangle is not in @yk/ui/icons; using TriangleAlert instead.
import {
  LayoutDashboard,
  ClipboardList,
  TriangleAlert,
  Users,
  Settings,
  Archive,
  Building2,
  UserCog,
  UserCheck,
  Wrench,
  FileText,
  CalendarDays,
  Layers,
  Network,
  Globe,
  Receipt,
  Bell,
} from "@yk/ui/icons";
import { usePermissions } from "@yk/frontend-core";
import { ROUTE_PERMISSIONS } from "./route-table.js";

// NavItem already declares permission?: string — no ShellNavItem wrapper needed.
const NAV: NavItem[] = [
  {
    label: "Dashboard",
    to: "/dashboard",
    icon: LayoutDashboard,
    testId: "nav-dashboard",
  },
  {
    label: "Complaints",
    to: "/complaints",
    icon: ClipboardList,
    testId: "nav-complaints",
    permission: ROUTE_PERMISSIONS["/complaints"],
  },
  {
    label: "Escalations",
    to: "/escalations",
    icon: TriangleAlert,
    testId: "nav-escalations",
    permission: ROUTE_PERMISSIONS["/escalations"],
  },
  {
    label: "Collective Cases",
    to: "/collective-cases",
    icon: Network,
    testId: "nav-collective-cases",
    permission: ROUTE_PERMISSIONS["/collective-cases"],
  },
  {
    label: "Technicians",
    to: "/technicians",
    icon: Users,
    testId: "nav-technicians",
    permission: ROUTE_PERMISSIONS["/technicians"],
  },
  {
    label: "Properties",
    to: "/properties",
    icon: Building2,
    testId: "nav-properties",
    permission: ROUTE_PERMISSIONS["/properties"],
  },
  {
    label: "Customers",
    to: "/customers",
    icon: UserCog,
    testId: "nav-customers",
    permission: ROUTE_PERMISSIONS["/customers"],
  },
  {
    label: "Assets",
    to: "/assets",
    icon: Archive,
    testId: "nav-assets",
    permission: ROUTE_PERMISSIONS["/assets"],
  },
  {
    label: "Asset Verifications",
    to: "/asset-verifications",
    icon: Archive,
    testId: "nav-asset-verifications",
    permission: ROUTE_PERMISSIONS["/asset-verifications"],
  },
  {
    label: "Asset Replacements",
    to: "/asset-replacements",
    icon: Wrench,
    testId: "nav-asset-replacements",
    permission: ROUTE_PERMISSIONS["/asset-replacements"],
  },
  {
    label: "Verification Reports",
    to: "/verification-reports",
    icon: ClipboardList,
    testId: "nav-verification-reports",
    permission: ROUTE_PERMISSIONS["/verification-reports"],
  },
  {
    label: "AMC Contracts",
    to: "/amc",
    icon: Receipt,
    testId: "nav-amc",
    permission: ROUTE_PERMISSIONS["/amc"],
  },
  {
    label: "Maintenance",
    to: "/maintenance",
    icon: CalendarDays,
    testId: "nav-maintenance",
    permission: ROUTE_PERMISSIONS["/maintenance"],
  },
  {
    label: "Inventory",
    to: "/inventory",
    icon: Layers,
    testId: "nav-inventory",
    permission: ROUTE_PERMISSIONS["/inventory"],
  },
  {
    label: "Reports",
    to: "/reports",
    icon: FileText,
    testId: "nav-reports",
    permission: ROUTE_PERMISSIONS["/reports"],
  },
  {
    label: "Configuration",
    to: "/config",
    icon: Wrench,
    testId: "nav-config",
    permission: ROUTE_PERMISSIONS["/config"],
  },
  {
    label: "Users",
    to: "/users",
    icon: UserCheck,
    testId: "nav-users",
    permission: ROUTE_PERMISSIONS["/users"],
  },
  {
    label: "Admin",
    to: "/admin",
    icon: Settings,
    testId: "nav-admin",
    permission: ROUTE_PERMISSIONS["/admin"],
  },
  {
    label: "Alerts & Notifications",
    to: "/alerts",
    icon: Bell,
    testId: "nav-alerts",
    permission: ROUTE_PERMISSIONS["/alerts"],
  },
  {
    label: "Platform",
    to: "/platform",
    icon: Globe,
    testId: "nav-platform",
    permission: ROUTE_PERMISSIONS["/platform"],
  },
];

/** Visible nav items for the current user (Dashboard always; others gated). */
export function useNavItems(): NavItem[] {
  const { can } = usePermissions();
  return NAV.filter((i) => !i.permission || can(i.permission));
}

export { NAV };
